var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 11.667V31.97H31.97V11.667H11.667ZM10.0003 6.66699C8.15938 6.66699 6.66699 8.15938 6.66699 10.0003V33.6367C6.66699 35.4776 8.15938 36.97 10.0003 36.97H33.6367C35.4776 36.97 36.97 35.4776 36.97 33.6367V10.0003C36.97 8.15938 35.4776 6.66699 33.6367 6.66699H10.0003Z",
    fill: "#C84B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 48.0303V68.3333H31.97V48.0303H11.667ZM10.0003 43.0303C8.15938 43.0303 6.66699 44.5227 6.66699 46.3636V70C6.66699 71.8409 8.15938 73.3333 10.0003 73.3333H33.6367C35.4776 73.3333 36.97 71.8409 36.97 70V46.3636C36.97 44.5227 35.4776 43.0303 33.6367 43.0303H10.0003Z",
    fill: "#C84B31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0303 11.667V31.97H68.3333V11.667H48.0303ZM46.3636 6.66699C44.5227 6.66699 43.0303 8.15938 43.0303 10.0003V33.6367C43.0303 35.4776 44.5227 36.97 46.3636 36.97H70C71.8409 36.97 73.3333 35.4776 73.3333 33.6367V10.0003C73.3333 8.15938 71.8409 6.66699 70 6.66699H46.3636Z",
    fill: "#C84B31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0303 48.0303V68.3333H68.3333V48.0303H48.0303ZM46.3636 43.0303C44.5227 43.0303 43.0303 44.5227 43.0303 46.3636V70C43.0303 71.8409 44.5227 73.3333 46.3636 73.3333H70C71.8409 73.3333 73.3333 71.8409 73.3333 70V46.3636C73.3333 44.5227 71.8409 43.0303 70 43.0303H46.3636Z",
    fill: "#C84B31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.7058666f1841fec2ab711dc14f9c2f6a.svg";
export { ForwardRef as ReactComponent };